
import Vue from "vue";
import Component from "vue-class-component";
import {f2mServicesSlugs, f2mSlugs} from "@/constants/f2mSlugs";
// import TrustpilotLogo from "@/assets/images/logo-trustpilot-white.svg";

@Component({
    components: {
        // TrustpilotLogo
    }
})
export default class Footer extends Vue {
    get footerLinks() {
        return  [
            {
                title: this.$t('personal-account.footer.links.company.title'),
                links: [
                    {
                        title: this.$t('personal-account.footer.links.blog'),
                        url: `/${this.getF2mLink('blog')}`,
                        key: 'blog'
                    },
                    {
                        title: this.$t('personal-account.footer.links.press'),
                        url: `/${this.getF2mLink('press')}`,
                        key: 'press'
                    },
                    {
                        title: this.$t('personal-account.footer.links.recruitment'),
                        url: "https://jobs.free2move.com/",
                        blank: true,
                        key: 'recruitment'
                    },
                    {
                        title: this.$t('personal-account.footer.links.cookies'),
                        url: "javascript:UC_UI.showFirstLayer()",
                        key: 'cookies'
                    },

                ]
            },
            {
                title: this.$t('personal-account.footer.links.contact.title'),
                links: [
                    {
                        title: this.$t('personal-account.footer.links.help'),
                        url: `/${this.getF2mLink('support')}`,
                        key: 'support'
                    }
                ]
            },
            {
                title: this.$t('personal-account.footer.links.services.title'),
                links: this.f2mKeys.map(key => ({
                    title: this.$t(`personal-account.header.${key}`),
                    url: `/${this.$language}-${this.$country}/${this.getF2mServiceLink(key)}`,
                    key
                }))
            },
        ]
    }
    get f2mKeys() {
        return Object.keys(f2mServicesSlugs).filter(key => this.getF2mServiceLink(key));
    }
    getF2mServiceLink (f2mKey: string) {
        return f2mServicesSlugs[f2mKey][`${this.$language}-${this.$country}`] || f2mServicesSlugs[f2mKey][this.$language] || f2mServicesSlugs[f2mKey]['*'];
    }
    getF2mLink (f2mKey: string) {
        return f2mSlugs[f2mKey][`${this.$language}-${this.$country}`] || f2mSlugs[f2mKey][this.$language] || f2mSlugs[f2mKey]['*'];
    }}
